import { render, staticRenderFns } from "./browsingHistory.vue?vue&type=template&id=de6737da&scoped=true"
import script from "./browsingHistory.vue?vue&type=script&lang=js"
export * from "./browsingHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6737da",
  null
  
)

export default component.exports